import Phaser from 'phaser';
import {
  collectPlayerLoadSpecs,
  PLAYER_LAYER_NAMES,
  type PlayerAnimState,
} from './player-specs';
import {
  bakeMergedPlayerSheet,
  loadSpritePack,
  PLAYER_COMPOSITE_ANIM,
  PLAYER_COMPOSITE_KEY,
  registerBakedPlayerTexture,
  removePlayerCompositeTexture,
  type SpritePack,
} from './player-mobile-bake';

export { removePlayerCompositeTexture };

export async function buildPlayerCompositeTexture(scene: Phaser.Scene, state: PlayerAnimState = 'Standing') {
  const specs = collectPlayerLoadSpecs(state);
  const packsByName: Record<string, SpritePack> = {};

  await Promise.all(
    specs.map(async (spec) => {
      packsByName[spec.name] = await loadSpritePack(spec.json, spec.img);
    }),
  );

  const layerOrder = PLAYER_LAYER_NAMES.filter((name) => packsByName[name]);
  const layerPacks = layerOrder.map((name) => packsByName[name]);
  if (!layerPacks.length) return false;

  const baked = bakeMergedPlayerSheet(layerPacks, layerOrder, packsByName);
  registerBakedPlayerTexture(scene, PLAYER_COMPOSITE_KEY, PLAYER_COMPOSITE_ANIM, baked);
  return true;
}
